import React from "react";
import styled from "@emotion/styled";
import PreviewSection from "../components/PreviewSection";
import CodeBlock from "../components/CodeBlock";
import { ExpandableItem } from "@atlas-int/ui";
import { spacing } from "@atlas-int/tokens";

const ItemList = styled.dl`
  margin: 0;
  padding: 0;
`;

const Spacer = styled.div`
  margin-bottom: ${spacing[8]};
`;

const ExpandableItemSection: React.FC = () => {
  return (
    <PreviewSection
      id="expandable-item"
      title="ExpandableItem"
      description="Expandable accordion item used in the Glossary and FAQ pages. Supports large and small label sizes."
    >
      <ItemList>
        <ExpandableItem
          term="Economic Complexity Index (ECI)"
          definition="The Economic Complexity Index ranks countries based on how diversified and complex their export basket is. Countries that are home to a great diversity of productive know-how, particularly complex specialized know-how, are able to produce a great variety of sophisticated products."
        />
        <ExpandableItem
          term="Revealed Comparative Advantage (RCA)"
          definition="An index used to calculate the relative advantage or disadvantage in a certain class of goods or services as evidenced by trade flows. A country is said to have a revealed comparative advantage in a product if it exports more than its 'fair share' (RCA > 1)."
        />
        <ExpandableItem
          term="Product Complexity Index (PCI)"
          definition="PCI ranks the diversity and sophistication of the productive know-how required to produce a product. Complex products are those that require a broad and sophisticated set of capabilities."
        />
      </ItemList>

      <Spacer />

      <ItemList>
        <ExpandableItem
          term="Small label variant"
          definition="Use smallLabel for more compact lists."
          smallLabel
        />
        <ExpandableItem
          term="Another small item"
          definition="This variant uses a smaller font size and tighter padding."
          smallLabel
        />
      </ItemList>

      <CodeBlock
        code={`import { ExpandableItem } from "@atlas-int/ui";

// Large label (default)
<ExpandableItem
  term="Economic Complexity Index"
  definition="A measure of the productive capabilities..."
/>

// Small label variant
<ExpandableItem
  term="Compact item"
  definition="Uses smaller font and tighter padding."
  smallLabel
/>`}
      />
    </PreviewSection>
  );
};

export default ExpandableItemSection;
